import { strings } from "@quickpoint.me/shared";
import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { ZoomFactor } from "../../../viewerati/src/state/accessibility";
import { Orientation } from "../state/uiAtoms";

function FrameSize() {
  const setOrientation = useSetRecoilState(Orientation);
  const setZoomFactor = useSetRecoilState(ZoomFactor);

  useEffect(() => {
    const measureOrientation = () => {
      // re-query: the app root remounts when the UI fork flips
      const app = document.getElementsByClassName(strings.css.authorUserInterfaceClass)[0] as HTMLDivElement;
      if (!app) return;
      const width = app.offsetWidth;
      const height = app.offsetHeight;

      // lets say 16:12 is threshold to switch to portrait...

      if (width / 12 < height / 16) {
        setOrientation(strings.ui.portrait);
      } else {
        setOrientation(strings.ui.landscape);
      }
    };

    const handleResize = () => {
      // Use devicePixelRatio for zoom detection
      const zoom = window.devicePixelRatio || 1;
      setZoomFactor(zoom);
      // rotating a phone must switch the UI live, no reload
      measureOrientation();
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    // Set initial values
    handleResize();

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, [setOrientation, setZoomFactor]);


  return <></>;
}

export default FrameSize;

